var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSimpleModal } from 'hx-ui';
export function useStyledModal(message, config) {
    return useSimpleModal(message, __assign({ modalProps: {
            sx: {
                minWidth: '70svw',
                backgroundSize: '100% 6px',
                backgroundColor: '#323232',
                color: '#fff',
                borderRadius: '32px',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.55)',
                '& > div:first-of-type': {
                    paddingTop: '64px',
                    paddingBottom: '40px',
                },
            },
        }, buttonProps: {
            className: 'french-nav-button sm:w-60 sm:max-w-60 py-3 w-full text-xl mb-16',
            variant: 'outlined',
            text: 'Suivant',
        } }, config));
}
